import React, { useMemo } from 'react';
import { MenuItem, Select } from '@mui/material';
import { minimalInputTheme } from '@/app/theme';
import { useSelector } from 'react-redux';
import { useGetUserDetailsQuery } from '@/features/user/userApi';
import { useListRelationshipContactsQuery } from '@/features/relationshipContacts/relationshipContactsApi';

const formatReferrerLabel = (contact) => {
	const email = contact?.email ?? '';
	const name = [contact?.firstName, contact?.lastName].filter(Boolean).join(' ').trim();
	if (email && name) return `${email} (${name})`;
	return email || name || '-';
};

export const ReferralPartnerSelect = ({ value, disabled, onChange, minimal }) => {
	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;

	const { data: userDetails } = useGetUserDetailsQuery({ email }, { skip: !email });
	const { data: referrers = [], isLoading } = useListRelationshipContactsQuery(
		{ relationshipType: 'referrer' },
		{ skip: !userDetails },
	);

	const options = referrers.filter((contact) => contact?.email);

	const selectedValue = useMemo(() => {
		if (!value) return '';
		return options.some((contact) => contact.email === value) ? value : '';
	}, [options, value]);

	return (
		<Select
			className={minimal ? 'minimal-input' : ''}
			value={selectedValue}
			size={minimal ? 'small' : 'medium'}
			disabled={disabled || isLoading}
			onChange={(e) => onChange(e.target.value)}
			displayEmpty
			fullWidth
			variant={minimal ? 'standard' : 'outlined'}
			sx={{
				...(minimal && {
					...minimalInputTheme,
					'& .Mui-disabled': {
						backgroundColor: 'transparent',
					},
				}),
			}}
		>
			<MenuItem value=''>None</MenuItem>
			{options.map((contact) => (
				<MenuItem key={contact.id ?? contact.email} value={contact.email}>
					{formatReferrerLabel(contact)}
				</MenuItem>
			))}
		</Select>
	);
};
